/* Mr Pixel v2 - the polish layer's behaviour (spec: Techne design/mr-pixel-v2-polish-audit, 2026-10-04).
 * Styles are mp2-polish.css. Every part is independent and does nothing when its hooks are absent.
 * No scroll listeners: visibility comes from IntersectionObserver. Loaded with defer from mp2-head. */
(() => {
  const still = window.matchMedia('(prefers-reduced-motion: reduce)');
  const ready = (fn) => (document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn) : fn());
  const hasPubSub = () => typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined';

  /* ---------------------------------------------------------------- polite announcements */
  let live;
  function say(text) {
    if (!live) {
      live = document.createElement('div');
      live.className = 'visually-hidden';
      live.setAttribute('role', 'status');
      live.setAttribute('aria-live', 'polite');
      document.body.appendChild(live);
    }
    live.textContent = '';
    if (text) setTimeout(() => { live.textContent = text; }, 60);
  }

  /* ---------------------------------------------------------------- the Press from the keyboard (sig 1) */
  document.addEventListener('keydown', (e) => {
    if ((e.key !== 'Enter' && e.key !== ' ') || e.repeat) return;
    const b = e.target.closest && e.target.closest('button, .btn, .button, .round-btn');
    if (!b) return;
    b.classList.add('is-pressed');
    setTimeout(() => b.classList.remove('is-pressed'), 120);
  });

  /* ---------------------------------------------------------------- busy buttons (sig 3) */
  // Checkout (Snap drawer + cart page) and the Pixel Club join: the loader goes in the moment it's pressed,
  // because the hand-off takes about a second and a second press is likely.
  document.addEventListener('click', (e) => {
    const b = e.target.closest && e.target.closest('.wizz-checkout-button, .cart__checkout-button');
    if (b) b.classList.add('mp2-busy');
  }, true);
  document.addEventListener('submit', (e) => {
    const f = e.target;
    // round 18: + the contact form and the Pixel Club page (Request a Game runs its own busy state)
    if (f && f.matches && f.matches('.mp2-club-form, form.fcard, .mp-club__form:not(.mp-req__form)')) {
      const b = f.querySelector('[type="submit"]');
      if (b) b.classList.add('mp2-busy');
    }
  });
  /* Round 18 (Jordan 2026-10-06): Afterpay on one line on a phone. Its own data-show-interest-free switch drops
     "interest-free" below 750px ("or 4 payments of $6.25 with afterpay"); the store's setting comes back above it.
     Re-applied when the product section re-renders. */
  (() => {
    const mq = window.matchMedia('(max-width: 749px)');
    const set = () => document.querySelectorAll('.product__info-container square-placement').forEach((p) => {
      if (p.dataset.mp2If === undefined) p.dataset.mp2If = p.getAttribute('data-show-interest-free') || 'true';
      const v = mq.matches ? 'false' : p.dataset.mp2If;
      if (p.getAttribute('data-show-interest-free') !== v) p.setAttribute('data-show-interest-free', v);
    });
    set();
    mq.addEventListener('change', set);
    document.querySelectorAll('product-info').forEach((el) => new MutationObserver(set).observe(el, { childList: true, subtree: true }));
  })();

  // Back from a checkout in the bfcache: drop the loaders.
  window.addEventListener('pageshow', (e) => { if (e.persisted) document.querySelectorAll('.mp2-busy').forEach((b) => b.classList.remove('mp2-busy')); });

  /* ---------------------------------------------------------------- Add to cart (sig 2, P-01) */
  const ATC = 'product-form [type="submit"][name="add"]';
  let stock = {}, inCart = {}, pending = null;

  function readStock() {
    const s = document.querySelector('script[data-mp2-buy]');
    if (!s) return;
    try { stock = JSON.parse(s.textContent).stock || {}; } catch (err) { stock = {}; }
  }
  async function refreshCart() {
    try {
      const url = ((window.routes && window.routes.cart_url) || '/cart') + '.js';
      const c = await (await fetch(url, { credentials: 'same-origin' })).json();
      inCart = {};
      (c.items || []).forEach((i) => { inCart[i.variant_id] = (inCart[i.variant_id] || 0) + i.quantity; });
    } catch (err) { /* keep what we had */ }
    syncAll();
  }
  function fx(btn) {
    let f = btn.querySelector(':scope > .mp2-atc-fx');
    if (!f) {
      f = document.createElement('span');
      f.className = 'mp2-atc-fx';
      f.setAttribute('aria-hidden', 'true');
      f.innerHTML = '<span class="s-adding"><i class="mp2-ld"></i>Adding</span>'
        + '<span class="s-added"><svg class="mp2-tick" viewBox="0 0 24 24"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>Added</span>'
        + '<span class="s-incart">In your cart · View cart</span>';
      btn.appendChild(f);
    }
    return f;
  }
  function setState(btn, s) {
    fx(btn);
    btn.dataset.mp2State = s;
    if (s === 'incart') btn.setAttribute('aria-label', 'In your cart. View cart');
    else btn.removeAttribute('aria-label');
    document.dispatchEvent(new CustomEvent('mp2:atc', { detail: { btn, state: s } }));
  }
  const variantOf = (btn) => { const f = btn.closest('product-form'); const i = f && f.querySelector('[name="id"]'); return i ? String(i.value) : null; };
  function full(btn) {
    const v = variantOf(btn);
    const st = v ? stock[v] : undefined;
    return typeof st === 'number' && st > 0 && (inCart[v] || 0) >= st;
  }
  function sync(btn) {
    const s = btn.dataset.mp2State;
    if (s === 'adding' || s === 'added') return;
    setState(btn, !btn.disabled && full(btn) ? 'incart' : 'idle');
  }
  function syncAll() { document.querySelectorAll(ATC).forEach(sync); }
  function openCart() {
    const bag = document.getElementById('cart-icon-bubble');
    if (bag) bag.click(); else window.location.href = (window.routes && window.routes.cart_url) || '/cart';
  }
  function done(btn) {
    clearTimeout(btn._mp2T);
    setState(btn, 'added');
    say('Added to cart');
    setTimeout(() => { btn.dataset.mp2State = 'idle'; sync(btn); }, still.matches ? 600 : 900);
  }
  function fail(btn) {
    clearTimeout(btn._mp2T);
    btn.dataset.mp2State = 'idle';
    sync(btn);
    say('');
  }

  // Capture phase on window, so this runs before the cart app's own click handler.
  window.addEventListener('click', (e) => {
    const btn = e.target.closest && e.target.closest(ATC);
    if (!btn) return;
    const s = btn.dataset.mp2State;
    if (s === 'adding' || s === 'added') { e.preventDefault(); e.stopImmediatePropagation(); return; }
    if (s === 'incart') { e.preventDefault(); e.stopImmediatePropagation(); openCart(); return; }
    if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
    pending = btn;
    setState(btn, 'adding');
    say('Adding to cart');
    clearTimeout(btn._mp2T);
    btn._mp2T = setTimeout(() => { if (btn.dataset.mp2State === 'adding') fail(btn); }, 12000);
  }, true);

  ready(() => {
    readStock();
    if (document.querySelector(ATC)) {
      syncAll();
      refreshCart();
      // Fallback when pubsub isn't there: Spotlight drops .loading when the request settles.
      new MutationObserver((list) => list.forEach((m) => {
        const btn = m.target;
        if (m.attributeName !== 'class' || !btn.matches(ATC) || btn.classList.contains('loading')) return;
        if (!m.oldValue || !m.oldValue.includes('loading') || btn.dataset.mp2State !== 'adding') return;
        setTimeout(() => {
          if (btn.dataset.mp2State !== 'adding') return;
          const err = btn.closest('product-form')?.querySelector('.product-form__error-message-wrapper:not([hidden])');
          if (err) fail(btn); else done(btn);
        }, 250);
      })).observe(document.body, { attributes: true, attributeFilter: ['class'], attributeOldValue: true, subtree: true });
    }
    if (hasPubSub()) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (ev) => {
        if (!ev || ev.source !== 'product-form') return;
        const d = ev.cartData;
        if (d && d.variant_id) inCart[d.variant_id] = d.quantity;
        const btn = pending; pending = null;
        if (btn && btn.dataset.mp2State === 'adding') done(btn);
      });
      subscribe(PUB_SUB_EVENTS.cartError, (ev) => {
        if (!ev || ev.source !== 'product-form') return;
        const btn = pending; pending = null;
        if (btn) fail(btn);
      });
      if (PUB_SUB_EVENTS.variantChange) subscribe(PUB_SUB_EVENTS.variantChange, () => setTimeout(syncAll, 60));
    }
    // A variant change can replace the button's markup; re-check whenever the form changes.
    document.addEventListener('change', (e) => { if (e.target.closest && e.target.closest('variant-selects, product-info')) setTimeout(syncAll, 120); });
    // The cart app edits the cart in its drawer: re-read the cart when it closes.
    let tries = 0;
    const hook = setInterval(() => {
      const dr = document.getElementById('wizz4-cart-drawer');
      if (dr || ++tries > 30) clearInterval(hook);
      if (!dr) return;
      new MutationObserver(() => { if (!dr.classList.contains('wizz4-visible')) refreshCart(); })
        .observe(dr, { attributes: true, attributeFilter: ['class'] });
    }, 1000);
  });

  /* ---------------------------------------------------------------- copy link (article share, 2026-10-05) */
  document.addEventListener('click', async (e) => {
    const b = e.target.closest && e.target.closest('[data-mp2-copy]');
    if (!b) return;
    const label = b.getAttribute('aria-label');
    try { await navigator.clipboard.writeText(b.dataset.mp2Copy || window.location.href); } catch (err) { return; }
    b.setAttribute('aria-label', 'Link copied');
    b.classList.add('is-done');
    say('Link copied');
    setTimeout(() => { b.setAttribute('aria-label', label); b.classList.remove('is-done'); }, 2000);
  });

  /* ---------------------------------------------------------------- scroll lock without the replay */
  // Drawers and modals lock the page with body{top:-Y} and restore it with scrollTo(0, Y) when they close.
  // Under v2's html{scroll-behavior:smooth} that restore played as a scroll down from the top of the page
  // (Jordan 2026-10-05, the cart drawer). While the body is locked, smooth scrolling is off; it comes back
  // just after the lock is released, once the restore has landed.
  ready(() => {
    const html = document.documentElement, body = document.body;
    let locked = false, t;
    const check = () => {
      const now = /top:\s*-/.test(body.getAttribute('style') || '');
      if (now === locked) return;
      locked = now;
      clearTimeout(t);
      if (now) html.style.scrollBehavior = 'auto';
      else t = setTimeout(() => { html.style.scrollBehavior = ''; }, 400);
    };
    new MutationObserver(check).observe(body, { attributes: true, attributeFilter: ['style'] });
    check();
  });

  /* ---------------------------------------------------------------- the bag bumps on add (K-07) */
  ready(() => {
    const count = () => {
      const n = document.querySelector('#cart-icon-bubble .cart-count-bubble span');
      return n ? parseInt(n.textContent, 10) || 0 : 0;
    };
    let last = count();
    const bag = document.getElementById('cart-icon-bubble');
    if (!bag) return;
    new MutationObserver(() => {
      const n = count();
      if (n > last && !still.matches) {
        const b = document.getElementById('cart-icon-bubble');
        b.classList.remove('mp2-bump'); void b.offsetWidth; b.classList.add('mp2-bump');
        setTimeout(() => b.classList.remove('mp2-bump'), 420);
      }
      last = n;
    }).observe(bag, { childList: true, subtree: true, characterData: true });
  });

  /* ---------------------------------------------------------------- pictures fade in over the mark (C-05) */
  function fadeImgs(scope) {
    (scope || document).querySelectorAll('.mp2 .prod .pic img, .mp2 .pb-t .ph img').forEach((img) => {
      if (img.dataset.mp2f) return;
      img.dataset.mp2f = '1';
      if (img.complete && img.naturalWidth) return;
      img.classList.add('mp2-fade');
      img.addEventListener('load', () => img.classList.add('is-in'), { once: true });
      img.addEventListener('error', () => img.classList.remove('mp2-fade'), { once: true });
    });
  }
  ready(() => {
    fadeImgs();
    const grid = document.getElementById('ProductGridContainer');
    if (grid) new MutationObserver(() => fadeImgs(grid)).observe(grid, { childList: true, subtree: true });
  });

  /* ---------------------------------------------------------------- ambient only on screen; stars fill once */
  ready(() => {
    if (!('IntersectionObserver' in window)) return;
    const amb = new IntersectionObserver((list) => list.forEach((en) => en.target.classList.toggle('mp2-off', !en.isIntersecting)), { rootMargin: '80px 0px' });
    document.querySelectorAll('.mp2 .announce, .mp2 .hero, .mp2 .plat, .mp2 .svc, .mp2 .feature, .mp2 .foot .club').forEach((el) => amb.observe(el));
    if (still.matches) return;
    const stars = document.querySelectorAll('.mp2 .score .stars');
    if (!stars.length) return;
    const io = new IntersectionObserver((list) => list.forEach((en) => {
      if (!en.isIntersecting) return;
      en.target.classList.add('is-in');
      io.unobserve(en.target);
    }), { threshold: 0.6 });
    stars.forEach((s) => {
      const r = s.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) return; // already on screen at load: leave it filled
      s.classList.add('mp2-pre');
      io.observe(s);
    });
  });

  /* ---------------------------------------------------------------- phone buy bar (P-07, M-08) */
  ready(() => {
    const main = document.querySelector('[id^="MainProduct-"] ' + ATC) || document.querySelector('.product ' + ATC);
    if (!main || !('IntersectionObserver' in window)) return;
    const phone = window.matchMedia('(max-width: 749px)');
    const section = main.closest('[id^="shopify-section"]') || document;
    const priceEl = () => section.querySelector('.price .price-item--sale, .price .price-item--regular, .price-item');
    const bar = document.createElement('div');
    bar.className = 'mp2-buybar';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Buy');
    const title = (section.querySelector('.product__title h1, h1') || {}).textContent || '';
    bar.innerHTML = '<span class="bb-price"><small></small><b></b></span><button type="button" name="add"><span></span></button>';
    bar.querySelector('small').textContent = title.trim();
    const bbtn = bar.querySelector('button');
    document.body.appendChild(bar);
    function mirror() {
      const p = priceEl();
      bar.querySelector('b').textContent = p ? p.textContent.trim() : '';
      const label = main.querySelector(':scope > span:not(.mp2-atc-fx)');
      bbtn.querySelector('span').textContent = label ? label.textContent.trim() : 'Add to cart';
      bbtn.disabled = main.disabled;
      const s = main.dataset.mp2State || 'idle';
      fx(bbtn);
      bbtn.dataset.mp2State = s;
    }
    bbtn.addEventListener('click', () => main.click());
    document.addEventListener('mp2:atc', (e) => { if (e.detail.btn === main) mirror(); });
    new MutationObserver(mirror).observe(main, { attributes: true, childList: true, subtree: true, characterData: true });
    let mainGone = false, footNear = false;
    function show() {
      const on = phone.matches && mainGone && !footNear;
      bar.classList.toggle('is-on', on);
      bar.inert = !on;
      document.body.classList.toggle('mp2-buybar-on', on);
    }
    new IntersectionObserver(([en]) => { mainGone = !en.isIntersecting && en.boundingClientRect.top < 0; show(); }).observe(main);
    const foot = document.querySelector('.shopify-section-group-footer-group');
    if (foot) new IntersectionObserver(([en]) => { footNear = en.isIntersecting; show(); }).observe(foot);
    phone.addEventListener('change', show);
    mirror();
    show();
  });
})();

/* Klaviyo popups (round 31m-n): on open Klaviyo focuses the close X (desktop: a ring as if Tab was pressed) or the
 * email field (phones: the keyboard pops up). Move that first focus to the dialog itself: focus stays inside the
 * popup, Tab still reaches the X, and a tap on the field still opens the keyboard. Only the first second is caught. */
window.addEventListener('klaviyoForms', (e) => {
  if (!e.detail || e.detail.type !== 'open') return;
  const until = Date.now() + 1000;
  const takeBack = (el) => {
    const dialog = el && el.closest && el.closest('[role="dialog"]');
    if (!dialog || !(el.classList.contains('klaviyo-close-form') || el.matches('input, textarea, select'))) return false;
    if (!dialog.hasAttribute('tabindex')) dialog.setAttribute('tabindex', '-1');
    dialog.style.outline = 'none';
    dialog.focus({ preventScroll: true });
    return true;
  };
  const onFocus = (ev) => { if (Date.now() > until || takeBack(ev.target)) document.removeEventListener('focusin', onFocus, true); };
  document.addEventListener('focusin', onFocus, true); // same task as Klaviyo's focus, before the keyboard opens
  [250, 500, 1000].forEach((ms) => setTimeout(() => { if (Date.now() <= until + 50) takeBack(document.activeElement); }, ms));
});